module.exports = {
	"id": "wdwd.skus.custom.get",
	"description": "根据外部 商品货号获取skus列表",
	"meta": {
		"oauth": true
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.skus.custom.get",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.skus.custom.get"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.skus.custom.get",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.skus.custom.get"
			}
		],
		"params": {
			"share": [],
			"private": [
				{
					"name": "bn",
					"type": "string",
					"required": true,
					"description": ""
				}
			]
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "skus",
				"type": "sku",
				"description": "返回订单信息（包括 商品ID，SKU的ID，商品货号，当前库存数）"
			}
		]
	},
	"structure": [
		{
			"name": "sku",
			"params": [
				{
					"name": "bn",
					"type": "string",
					"enumerable": false,
					"description": "商品货号"
				},
				{
					"name": "num",
					"type": "string",
					"enumerable": false,
					"description": "当前库存个数"
				},
				{
					"name": "num_iid",
					"type": "string",
					"enumerable": false,
					"description": "商品的ID"
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "sku的ID"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.skus.custom.get.json
 ** module id = 531
 ** module chunks = 1
 **/